import { render, staticRenderFns } from "./WarringList.vue?vue&type=template&id=5ea0ba40&scoped=true"
import script from "./WarringList.vue?vue&type=script&lang=js"
export * from "./WarringList.vue?vue&type=script&lang=js"
import style0 from "./WarringList.vue?vue&type=style&index=0&id=5ea0ba40&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea0ba40",
  null
  
)

export default component.exports